<template>
  <transition name="fade" mode="out-in">
    <div class="faq" v-smoothscroll="{ duration : 500 }">
      <faqEntry></faqEntry>
      <faqQuestions></faqQuestions>
      <faqNextPage></faqNextPage>
    </div>
  </transition>
</template>

<script>

export default {

}

</script>
